var render = function render(){var _vm=this,_c=_vm._self._c;return _c('universal-uploader',{staticClass:"text-truncate",attrs:{"clientAllowedFormats":['image', 'video']},on:{"uploadSuccess":_vm.uploadSuccess}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }